var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhotoshooting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.953 37.182H38.061l1.891-6.748c.08-.262.06-.545-.06-.788a.999.999 0 00-.6-.505l-1.281-.424v-4.666c0-1.112-.9-2.02-2-2.02h-3.002V19h-6.003v3.03h-3.002c-1.1 0-2 .91-2 2.02v4.667l-1.291.424a.999.999 0 00-.6.506c-.12.242-.15.525-.06.787l1.9 6.748zm2.051-13.132H36.01v4.01l-6.003-1.99-6.003 1.99v-4.01z",
    fill: "#E3B05F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 14.444v31.112C48 48 46.2 50 44 50H16c-2.2 0-4-2-4-4.444V14.444C12 12 13.8 10 16 10h28c2.2 0 4 2 4 4.444zM18 14a2 2 0 00-2 2v24a2 2 0 002 2h24a2 2 0 002-2V16a2 2 0 00-2-2H18z",
    fill: "#E3B05F"
  })));
}

export default SvgPhotoshooting;